module.exports = __webpack_public_path__ + "media/images/tw-icon-fee2351a.png";